export default __webpack_public_path__ + "static/media/source.1747155d.svg";